import React, { ReactNode } from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { BasicLayout } from '@monorepo/common';

import DashboardNavigation from './DashboardNavigation';

interface IDashboardPageProps {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  isLoading?: boolean;
  noAccessComponent?: ReactNode;
  hideTitle?: boolean;
}

export const DashboardPage = ({
  title,
  children,
  actions,
  isLoading,
  noAccessComponent,
  hideTitle = false,
}: IDashboardPageProps) => (
  <BasicLayout
    isLoading={isLoading}
    noAccessComponent={noAccessComponent}
    helmet={(
      <title>{title} | CPG Jobs</title>
    )}
  >
    <Box sx={{ borderBottom: '1px solid var(--line-soft)' }}>
      <Container maxWidth="lg">
        <DashboardNavigation />
      </Container>
    </Box>
    <Container maxWidth="lg" sx={{ pb: { xs: 6, md: 9 } }}>
      {!hideTitle ? (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          sx={{ mb: 3, pt: { xs: 4, md: 5 } }}
        >
          <Typography component="h1" variant="h4">
            {title}
          </Typography>
          {actions ? <Box sx={{ flexShrink: 0 }}>{actions}</Box> : null}
        </Stack>
      ) : null}
      {children}
    </Container>
  </BasicLayout>
);

export default DashboardPage;
